import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ImagePlaceholderNodeView from '../components/ui/ImagePlaceholderNodeView';

export interface ImagePlaceholderOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    imagePlaceholder: {
      insertImagePlaceholder: () => ReturnType;
    };
  }
}

export const ImagePlaceholderExtension = Node.create<ImagePlaceholderOptions>({
  name: 'imagePlaceholder',
  group: 'block',
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => element.getAttribute('data-placeholder-id'),
        renderHTML: attributes => ({
          'data-placeholder-id': attributes.id,
        }),
      },
      text: {
        default: 'Add an image',
        parseHTML: element => element.getAttribute('data-placeholder-text'),
        renderHTML: attributes => ({
          'data-placeholder-text': attributes.text,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-image-placeholder]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
      'data-image-placeholder': 'true',
      'data-placeholder-id': HTMLAttributes['data-placeholder-id'],
      'data-placeholder-text': HTMLAttributes['data-placeholder-text'],
    })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImagePlaceholderNodeView);
  },

  addCommands() {
    return {
      insertImagePlaceholder:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              id: `placeholder-${Date.now()}`,
              text: 'Add an image',
            },
          });
        },
    };
  },
});
